<template>
  <div class="space-y-6">
    <div>
      <h3 class="text-lg font-medium mb-4">
        {{ t("settings.general") }}
      </h3>

      <!-- Language Setting -->
      <div class="flex justify-between items-center py-3">
        <div class="text-sm font-medium">
          {{ t("appSettingsDropdown.language") }}
        </div>
        <Select v-model="locale">
          <SelectTrigger class="max-w-[100px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem v-for="l in locales" :key="l" :value="l">
              {{ l }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <!-- Theme Setting -->
      <div class="flex justify-between items-center py-3">
        <div class="text-sm font-medium">
          {{ t("appSettingsDropdown.theme") }}
        </div>
        <Select v-model="colorMode.preference">
          <SelectTrigger class="max-w-[100px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="system">{{ t("colorModes.system") }}</SelectItem>
            <SelectItem value="light">{{ t("colorModes.light") }}</SelectItem>
            <SelectItem value="dark">{{ t("colorModes.dark") }}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLocale } from "~/composables/useLocale";

const colorMode = useColorMode();
const { locales, locale } = useLocale();

const { t } = useI18n();
</script>
